export const digits = (text: string) => {

  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  let e = '۰'.charCodeAt(0);
  text = text.replace(/[۰-۹]/g, sub => (sub.charCodeAt(0) - e as any));

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = '٠'.charCodeAt(0);
  text = text.replace(/[٠-٩]/g, sub => sub.charCodeAt(0) - e as any);
  return text;
}

export const farsiDigits = (text: string) => {
  const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return text.replace(/\d/g, x => farsiDigits[x]);
}
